export default __webpack_public_path__ + "static/img-ei-9-eab87d18fd411de746be692f733bae8b.png";